import { render, staticRenderFns } from "./RequestDiagnosticTestModal.vue?vue&type=template&id=43a2f784&"
import script from "./RequestDiagnosticTestModal.vue?vue&type=script&lang=js&"
export * from "./RequestDiagnosticTestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports